export const searchConstants = {
    START_SEARCH : 'START_SEARCH',
    RECEIVE_SEARCH_RESULTS : 'RECEIVE_SEARCH_RESULTS',
    LOAD_COURSES : 'LOAD_COURSES',
};